<template>
    <div class="login">
        <div class="step1" v-if="step === '1'">
          <p class="title">快捷登录</p>
          <div class="inputbox" style="top: 4.333rem;">
              <select ref="qhSelect">
                <option value="86">+86</option>
                <option value="852">+852</option>
                <option value="886">+886</option>
                <option value="1">+1</option>
                <option value="81">+81</option>
                <option value="82">+82</option>
                <option value="60">+60</option>
                <option value="65">+65</option>
                <option value="61">+61</option>
                <option value="44">+44</option>
                <option value="7">+7</option>
              </select>
              <input ref="phoneInput" placeholder="请输入手机号" />
          </div>
          <div class="inputbox" style="top: 6.227rem;">
            <input style="margin-left: 0.44rem;" placeholder="请输入右侧的验证码" ref="picVcodeIuput" />
            <a @click="getpicVcode" v-if="picVcode.length" class="vCode" v-bind:style="{backgroundImage: picVcode,backgroundSize: '100%,100%'}"></a>
          </div>
          <div class="goNext">
            <a @click="goNext" class="downloadButton">确定</a>
            <img class="downloadButtonShadow" src="/static/downloadshadow.png">
          </div>
        </div>
        <div class="step2" v-if="step === '2'">
          <a class="back" @click="goback" ></a>
          <p class="title">输入验证码</p>
          <div class="tip">
            <p>验证码已发送至 +{{qhstr}} {{phoneNum}}</p>
            <a class="xg" @click="goback"></a>
          </div>
          <div class="inputbox" style="top: 6.227rem;">
            <input ref="dxIuput" style="margin-left: 0.44rem;" placeholder="请输入短信验证码" />
            <div v-if="!dxyzm" style="background-color: #FCEF22" class="vCode" v-on:click="getSmsCode">验证码</div>
            <div v-if="dxyzm" class="vCode">{{dxyzmtime}}s</div>
          </div>
          <div class="goNext">
            <a  class="downloadButton" @click="login" >登录</a>
            <img class="downloadButtonShadow" src="/static/downloadshadow.png">
          </div>
        </div>
        <div class="successTip" v-if="TipStutas">
          {{TipStutasText}}
        </div>
    </div>
</template>

<script>
import uuid from 'uuid'
import Config from '../config/index'
import callApi from '../../static/callApi'

export default {
  name: 'login',
  data () {
    return {
      step: '1',
      picVcode: '',
      uuid: '',
      dxyzm: false,
      dxyzmtime: 60,
      TipStutas: false,
      TipStutasText: '',
      phoneNum: '',
      picVcodeStr: '',
      qhstr: ''
    }
  },
  created: function () {
    let uuidts = uuid.v1()
    let _this = this
    callApi({
      method: 'get',
      url: Config.path + '/fbeeapi/act/login/verification/stream',
      responseType: 'blob',
      headers: {uuid: uuidts, versioncode: 1.0, platform: 'ios', 'Content-Type': 'image/png'}
    }, (response) => {
      let blob1 = window.URL.createObjectURL(response.data)
      _this.picVcode = 'url("' + blob1 + '")'
      _this.uuid = uuidts
    }, this)
  },
  methods: {
    getpicVcode: function () {
      let uuidts = uuid.v1()
      let _this = this
      callApi({
        method: 'get',
        url: Config.path + '/fbeeapi/act/login/verification/stream',
        responseType: 'blob',
        headers: {uuid: uuidts, versioncode: 1.0, platform: 'ios', 'Content-Type': 'image/png'}
      }, (response) => {
        let blob1 = window.URL.createObjectURL(response.data)
        _this.picVcode = 'url("' + blob1 + '")'
        _this.uuid = uuidts
      }, this)
    },
    openmessage: function (msg) {
      let _this = this
      this.TipStutasText = msg
      this.TipStutas = true
      setTimeout(function () {
        _this.TipStutasText = ''
        _this.TipStutas = false
      }, 2000)
    },
    goNext: function () {
      let phoneexp = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      if (!phoneexp.test(this.$refs.phoneInput.value)) {
        this.openmessage('请填写正确的手机号码')
        return false
      } else if (this.$refs.picVcodeIuput.value === '') {
        this.openmessage('请填写图片验证码')
        return false
      } else {
        this.phoneNum = this.$refs.phoneInput.value
        this.picVcodeStr = this.$refs.picVcodeIuput.value
        this.qhstr = this.$refs.qhSelect.value
        this.getSmsCode()
      }
    },
    getSmsCode: function () {
      let _this = this
      callApi({
        method: 'get',
        url: Config.path + '/fbeeapi/act/login/smscode',
        headers: {uuid: this.uuid, versioncode: 1.0, platform: 'ios'},
        params: {mobile: this.phoneNum, code: this.picVcodeStr, area: this.qhstr}
      }, (response) => {
        if (response.data.success === '1') {
          _this.openmessage('短信发送成功请查看手机')
          _this.step = '2'
          _this.dxyzm = true
          let yzm = setInterval(() => {
            if (_this.dxyzmtime === 0) {
              clearInterval(yzm)
              _this.dxyzm = false
              _this.dxyzmtime = 60
            } else {
              _this.dxyzmtime = _this.dxyzmtime - 1
            }
          }, 1000)
        } else if (response.data.success === '000159') {
          _this.openmessage('图片验证码错误')
        } else {
          _this.openmessage(response.data.message)
        }
      }, this)
    },
    goback: function () {
      this.step = '1'
      this.picVcode = ''
      this.uuid = ''
      this.dxyzm = false
      this.dxyzmtime = 60
      this.TipStutas = false
      this.TipStutasText = ''
      this.phoneNum = ''
      this.picVcodeStr = ''
      this.qhstr = ''
      this.getpicVcode()
    },
    login: function () {
      let _this = this
      if (this.$refs.dxIuput.value === null) {
        this.openmessage('请填写短信验证码')
      } else {
        callApi({
          method: 'post',
          url: Config.path + '/fbeeapi/asset/login',
          headers: {uuid: this.uuid, versioncode: 1.0, platform: 'smallprogram'},
          params: {mobile: this.phoneNum, code: this.$refs.dxIuput.value, area: this.qhstr}
        }, (response) => {
          if (response.data.success === '1') {
            _this.openmessage('登陆成功')
            localStorage.setItem('token', response.data.content.user.token)
            localStorage.setItem('nickname', response.data.content.user.nickname)
            localStorage.setItem('uuid', _this.uuid)
            localStorage.setItem('uid', response.data.content.user.id)
            _this.$router.push({path: '/'})
          } else {
            _this.openmessage('登陆失败，请重试')
          }
        }, this)
      }
    }
  }
}
</script>

<style scoped>
  input::-webkit-input-placeholder{
    color:#C6C5CC;
    font-size: 0.427rem;
    line-height: 0.533rem;
  }
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#C6C5CC;
    font-size: 0.427rem;
    line-height: 0.533rem;
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#C6C5CC;
    font-size: 0.427rem;
    line-height: 0.533rem;
  }
  input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#C6C5CC;
    font-size: 0.427rem;
    line-height: 0.533rem;
  }
  .step1 .close{
    position: absolute;
    display: block;
    background-image: url("/static/close.png");
    height: 0.4rem;
    width: 0.4rem;
    background-size: 100%;
    background-repeat: no-repeat;
    left: 0.427rem;
    top: 0.28rem;
  }
  .title{
    position: absolute;
    font-family: PingFangSC-Medium;
    font-size: 0.907rem;
    color: #584F60;
    left: 0.427rem;
    top: 1.147rem;
  }
  .inputbox{
    width: 7.467rem;
    height: 1.333rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: #F9F8FC;
    border-radius: 1.333rem;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }
  .inputbox select{
    margin-left: 0.44rem;
    outline: none;
    background-color: transparent;
    border: none;
    appearance:none;
    -moz-appearance:none; /* Firefox */
    -webkit-appearance:none; /* Safari and Chrome */;
    /* +86: */
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #4A90E2;
    width: 1.333rem;
    background: url("/static/selectSJ.png") no-repeat  100% center/0.3rem 0.3rem transparent
  }
  .inputbox>span{
    display: block;
    background: #FCEC22;
    border-radius: 0.3333rem;
    width: 0.053333rem;
    height: 0.8rem;
  }
  .inputbox>input{
    border: none;
    background-color: transparent;
    outline: none;
    text-indent: 0.1rem;
    height: 1.333rem;
    font-size: 0.427rem;
    font-family: PingFangSC-Regular;
    caret-color: #000000;
    width: 4.8rem;
  }
  .inputbox>.vCode{
    background: #D1CFD8;
    border-radius: 1.333rem;
    width: 1.84rem;
    height: 0.933rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #686670;
    text-align: center;
    line-height: 0.9333rem;
    background-position: center center;
  }
  .goNext{

  }
  .downloadButton{
    font-family: PingFangSC-Regular;
    font-size: 0.373rem;
    color: #744A05;
    text-align: center;
    background-image: linear-gradient(-165deg, #FCEF22 0%, #FFDA28 100%);
    border-radius: 1.333rem;
    width: 7.467rem;
    height: 1.333rem;
    display: block;
    position: absolute;
    top: 8.24rem;
    line-height: 1.333rem;
    transform: translateX(-50%);
    left: 50%;
    z-index: 3;
  }
  .downloadButtonShadow{
    position: absolute;
    z-index: 2;
    width: 7.467rem;
    height: 1.733rem;
    left: 50%;
    transform: translateX(-50%);
    top: 8.24rem;
    border-radius: 1.3333rem;
  }
  .step2 .back{
    position: absolute;
    display: block;
    background-image: url("/static/goback.png");
    height: 0.4rem;
    width: 0.24rem;
    background-size: 100%;
    background-repeat: no-repeat;
    left: 0.427rem;
    top: 0.28rem;
  }
  .tip{
    position: absolute;
    left: 0.427rem;
    top: 2.56rem;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }
  .tip p{
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #9B9B9B;
  }
  .tip>.xg{
    width: 0.373rem;
    height: 0.453rem;
    background-image: url("/static/xg.png");
    background-size: 100%;
    margin-left: 0.56rem;
  }
  .successTip{
    opacity: 0.8;
    background: #000000;
    border-radius: 0.267rem;
    position: fixed;
    top: 7.147rem;
    left: 50%;
    transform: translateX(-50%);
    height: 2.66667rem;
    width: 5.333rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue